import moment from 'moment/moment'
import {
  generateAllergiesDataSkeleton,
  generateIntakeFormsDataSkeleton,
  generatePastVisitsDataSkeleton,
  generatePrescriptionsDataSkeleton,
} from '../helpers'
import { capitalize, getBodyHeightValue } from '../../../../utils/common'
import {
  getMaritalRow,
  getRacialRow,
} from '../../../patient-chart-page/components/general-information-section/tools/tools'
import { DATE_FORMAT_SLASH } from '../../../../utils/dateUtils'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const dataSkeletonGenerator = (patientChartPrintedInfo, userTimeZone) => {
  const {
    FirstName,
    LastName,
    MedicalRecordNumber,
    BirthDate,
    PhoneNumber,
    Email,
    Address,
    Pharmacy,
    EmergencyContact,
    Allergies,
    HeightInches,
    WeightPounds,
    MaritalStatus,
    Gender,
    GenderIdentity,
    RacialBackground,
    Prescriptions,
    PastVisits,
    IntakeForms,
  } = patientChartPrintedInfo || {}

  const { Prefix, Number } = PhoneNumber || {}
  const { StreetAddress1, StreetAddress2, City, Zip, StateCode, CountryCode } = Address || {}
  return [
    {
      title: 'Patient records',
      properties: [
        {
          content: [
            {
              name: 'Name',
              value: `${FirstName} ${LastName}`,
            },
            { name: 'MRN', value: MedicalRecordNumber || '--' },
            { name: 'DOB', value: moment(BirthDate).format(DATE_FORMAT_SLASH) },
          ],
          propertyTitle: 'Patient information',
        },
      ],
    },
    {
      title: 'Account information',
      properties: [
        {
          content: [
            {
              name: 'Phone',
              value: `${Prefix} ${Number?.substr(Prefix?.length)}`,
            },
            { name: 'Email', value: Email },
            {
              name: 'Street address',
              value: `${StreetAddress1 ? `${StreetAddress1}, ` : ''}${
                StreetAddress2 ? `${StreetAddress2}, ` : ''
              }${City ? `${City}, ` : ''}${StateCode || ''}${Zip ? ` ${Zip}` : ''},${
                CountryCode ? ` ${CountryCode}` : ''
              }`,
            },
            {
              name: 'Preferred pharmacy',
              value:
                Pharmacy ?
                  `${Pharmacy?.Name} - ${Pharmacy?.Address?.StreetAddress1}, ${
                    Pharmacy?.Address?.StreetAddress2 ? `${Pharmacy?.Address?.StreetAddress2}, ` : ''
                  }${Pharmacy?.Address?.City}, ${Pharmacy?.Address?.StateCode} ${Pharmacy?.Address?.Zip}, ${
                    Pharmacy?.Address?.CountryCode
                  }`
                : '--',
            },
          ],
          propertyTitle: 'Contact',
        },
        {
          content: [
            {
              name: 'First name',
              value: `${EmergencyContact?.FirstName ?? '--'}`,
            },
            { name: 'Last name', value: `${EmergencyContact?.LastName ?? '--'}` },
            {
              name: 'Relationship to patient',
              value: `${EmergencyContact?.Relationship ?? '--'}`,
            },
            {
              name: 'Phone',
              value:
                EmergencyContact?.PhoneNumber.Number ?
                  `${EmergencyContact?.PhoneNumber.Prefix} ${EmergencyContact?.PhoneNumber.Number.substr(
                    EmergencyContact?.PhoneNumber.Prefix.length,
                  )}`
                : '--',
            },
          ],
          propertyTitle: 'Emergency contact',
        },
      ],
    },
    {
      title: 'General information',
      properties: [
        ...generateAllergiesDataSkeleton(Allergies),
        {
          content: [
            {
              name: 'Height',
              value: HeightInches ? `${getBodyHeightValue(HeightInches)}` : '--',
            },
            {
              name: 'Weight',
              value: WeightPounds ? `${WeightPounds} lbs` : '--',
            },
          ],
          propertyTitle: 'Body measurements',
        },
        {
          content: [
            {
              name: 'Marital status',
              value: MaritalStatus ? getMaritalRow(MaritalStatus) : '--',
            },
            {
              name: 'Sex at birth',
              value: Gender ? capitalize(Gender) : '--',
            },
            {
              name: 'Gender identity',
              value: GenderIdentity ?? '--',
            },
            {
              name: 'Racial background',
              value: RacialBackground ? getRacialRow(RacialBackground) : '--',
            },
          ],
          propertyTitle: 'Identity',
        },
      ],
    },
    {
      title: 'Orders',
      properties: [...generatePrescriptionsDataSkeleton(Prescriptions, userTimeZone)],
      emptyText: 'No orders.',
    },
    {
      title: 'Past visits',
      properties: [...generatePastVisitsDataSkeleton(PastVisits, userTimeZone)],
      isPastVisitVariant: true,
      emptyText: 'No past visits.',
    },
    {
      title: 'Intake forms',
      properties: [...generateIntakeFormsDataSkeleton(IntakeForms, userTimeZone)],
      isIntakeFormVariant: true,
      emptyText: 'No intake forms.',
    },
  ]
}
